import { ReactElement, useState } from 'react'
import { isMobileDevice } from '../molecules/MobileDetectionWrapper/MobileDetectionWrapper'

export const MOBILE_SURVEY_COMPLETE_MESSAGE =
  'Thank you for completing this Debrief. To access the rest of your Portal, please use your personal computer or tablet to sign in.'

// Shown after a survey is completed on a phone, in place of navigating into the portal.
export const MobileSurveyCompletionMessage = (): ReactElement => (
  <div className='bg-dopage-black min-h-screen flex items-center justify-center text-dopage-lightGreen font-primary text-center p-6'>
    {MOBILE_SURVEY_COMPLETE_MESSAGE}
  </div>
)

// Gates survey completion on a phone. `gateMobileCompletion()` returns true and shows
// the message when on mobile (caller should then skip its portal navigation), false otherwise.
export const useMobileSurveyCompletion = (): {
  showMobileCompletion: boolean
  gateMobileCompletion: () => boolean
} => {
  const [showMobileCompletion, setShowMobileCompletion] = useState(false)
  const gateMobileCompletion = (): boolean => {
    if (isMobileDevice()) {
      setShowMobileCompletion(true)
      return true
    }
    return false
  }
  return { showMobileCompletion, gateMobileCompletion }
}
